import { Col, Form, Row } from 'react-bootstrap';
import TextInput from 'src/Components/GenericInputText/TextInput';

const CoolOffPeriod = ({ values, setFieldValue, errors, touched }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Cool‑off Period</h3>
        <p>Define the cool-off duration post multiple unlock attempt(s).</p>
      </Col>
      <Col md={5} lg={5} sm={5}>
        <div className="retroactive-days-label">
          Cool‑Off Duration(in minutes)
        </div>
        <Row className="pt-2">
          <Col>
            <TextInput
              inputProps={{
                name: 'CoolOffPeriod',
                isInvalid: false,
                placeholder: '',
                value: values.CoolOffPeriod,
                onChange: (e) => {
                  setFieldValue('CoolOffPeriod', e.target.value);
                },
              }}
            />
            <Form.Control.Feedback
              type="invalid"
              aria-live="polite"
              id="err_title"
              role="alert"
              className="d-block"
            >
              <span>
                {touched.MaxUnlockAttempts && errors.MaxUnlockAttempts}
              </span>
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CoolOffPeriod;
